module.exports = __webpack_public_path__ + "img/c2-m.d1e60cd6.jpg";